import { ChangeDetectionStrategy, Component, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { PaginatedStateLoadingMode, SearchableSingleSelectorComponent } from '@shared/ui';
import { workspaceStoreProviders } from '../../../providers/store.providers';
import { CompatibleWSDialogData, CompatibleWSDialogFacade } from './compatible-ws-dialog.facade';

@Component({
    selector: 'ts-compatible-ws-dialog',
    templateUrl: './compatible-ws-dialog.component.html',
    styleUrls: ['./compatible-ws-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule, SearchableSingleSelectorComponent],
    providers: [...workspaceStoreProviders(PaginatedStateLoadingMode.CONTINUOUS), CompatibleWSDialogFacade]
})
export class CompatibleWSDialogComponent {
  constructor(
    @Optional() public dialogRef: MatDialogRef<CompatibleWSDialogComponent>,
    private readonly facade: CompatibleWSDialogFacade
  ) {}

  public readonly data: CompatibleWSDialogData = this.facade.data;
  public readonly options$ = this.facade.workspaceOptions$;
  public readonly loaded$ = this.facade.loaded$;

  public selectedWorkspaceId: string | undefined;

  get readyToAccept(): boolean {
    return !!this.selectedWorkspaceId;
  }

  selectWorkspace(id: string): void {
    this.selectedWorkspaceId = id;
  }

  onLastItemReached(): void {
    this.facade.loadMoreWorkspaces(undefined);
  }

  searchWorkspace(term: string): void {
    this.facade.setSearchTerm(term);
  }

  cancel(): void {
    this.dialogRef?.close('cancel');
  }

  accept(): void {
    this.dialogRef?.close(this.selectedWorkspaceId);
  }
}
